module.exports = __webpack_public_path__ + "static/media/2.6bd17f81.jpg";